import { createContext, useState, useEffect } from "react";
import { createUserDocumentFromAuth, onAuthStateChangedListener } from "../utils/firebase/firebase.utils";

export const UserContext = createContext({
    currentUser: null,
    userID: null,
    profileImageUrl: '', // Add profileImageUrl to the initial context value
    setCurrentUser: () => null,
    setUserID: () => null, // Add setUserID here to the initial context value
    setProfileImageUrl: () => null,
});

export const UserProvider = ({ children }) => {
    const [currentUser, setCurrentUser] = useState(null);
    const [userID, setUserID] = useState(null);
    const [profileImageUrl, setProfileImageUrl] = useState('https://static.vecteezy.com/system/resources/thumbnails/002/318/271/small_2x/user-profile-icon-free-vector.jpg'); // Default URL

    const value = { currentUser, setCurrentUser, userID, setUserID, profileImageUrl, setProfileImageUrl };

    useEffect(() => {
        const unsubscribe = onAuthStateChangedListener(async (user) => {
            if (user) {
                const userDocRef = await createUserDocumentFromAuth(user);
                if (userDocRef && userDocRef.id) {
                    setUserID(userDocRef.id); // Set the userID
                }

                // Fetch user profile image if available (you would add logic to fetch from Firebase here)
                if (user.profileImageUrl) {
                    setProfileImageUrl(user.profileImageUrl); // Set profileImageUrl from user's document
                }
            }
            setCurrentUser(user);
        });

        return unsubscribe;
    }, []);

    return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};
